// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-50c14cdd] {\n  -webkit-appearance: menu-item;\n  -moz-appearance: menu-item;\n  appearance: menu-item;\n  height: 3em;\n}\n", ""]);
// Exports
module.exports = exports;
